import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.showModal()
    this.element.addEventListener('close', () => {
      setTimeout(() => {
        this.element.remove()
      }, 50)
    })
  }

  remove() {
    this.element.close()
  }
} 